Object.defineProperty
	(
		HTMLImageElement.prototype, 'toDataURL',
		{
			enumerable: false, configurable: false, writable: false, value (m: any, q: any) {
				const c = document.createElement('canvas');
				c.width = this.naturalWidth; c.height = this.naturalHeight;
				c.getContext('2d').drawImage(this, 0, 0); return c.toDataURL(m, q);
			}
		}
	);/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */  // Run `npm install --save classlist.js`.  // Run `npm install --save web-animations-js`.  // Run `npm install --save web-animations-js`.



/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.

(window as any).global = window;

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
/*import 'url-search-params-polyfill';
require('datejs');
(Date as any).prototype.strtotime = (time) => {
	const d: any = Date.parse(time);
	d.addMinutes(d.getTimezoneOffset() * -1);
	return Math.round(
		Date.UTC(d.getUTCFullYear(),
			d.getUTCMonth(),
			d.getUTCDate(),
			d.getUTCHours(),
			d.getUTCMinutes(),
			d.getUTCSeconds(),
			d.getUTCMilliseconds()) / 1000);
};
(window as any).global = window;
*/
